import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


const changePasswordValidator: ValidatorFn = (c: AbstractControl):  ValidationErrors | null => {

    const regex1 = new RegExp(/([A-Z]+)/)
    const regex2 = new RegExp(/([0-9]+)/)
    const regex3 = new RegExp(/([^A-Za-z0-9]+)/)
    let password = c?.value || ''
    //console.log(password);

    if(((password.match(regex1)) && password.match(regex2) && password.match(regex3))){
     // console.log('ok')
      return null
    }
    //console.log('nooo')
    return {formatError: true }
}

export default changePasswordValidator ;
